import React, {useMemo} from 'react'
import {Button, Label, Loading, Modal} from '@therms/atalaya'
import {useReportEntryTypesByIds} from '@therms/react-modules'
import {groupBy} from 'lodash-es'
import {getColorContrast} from '@therms/web-js'

interface SelectEntryTypeModalProps {
  closeHandler: () => void
  entryTypeIds: string[]
  onSelectEntryType: (entryTypeId: string) => void
}

function SelectEntryTypeModal({
  closeHandler,
  entryTypeIds,
  onSelectEntryType,
}: SelectEntryTypeModalProps) {
  const {data: entryTypesData, loading: entryTypesDataLoading} =
    useReportEntryTypesByIds({
      entryTypeIds,
    })

  const entryTypesCategoryDouble = useMemo(() => {
    if (!entryTypesData?.entryTypes) return []

    const grouped = groupBy(entryTypesData.entryTypes, 'category')

    return Object.entries(grouped).sort((a, b) => (a[0] > b[0] ? -1 : 1))
  }, [entryTypesData])

  return (
    <Modal closeHandler={closeHandler} escPressClose header="Pick Entry Type">
      {entryTypesDataLoading && !entryTypesCategoryDouble?.length && (
        <Loading message="Loading Entry Types" overlay />
      )}

      {entryTypesCategoryDouble.map(([category, entryTypes]) => (
        <div className="gap-y-base mt-3 flex flex-col" key={category}>
          <Label>{category}</Label>

          <div className="gap-x-base inline-flex flex-wrap">
            {entryTypes.map((entryType) => (
              <Button
                key={entryType.id}
                onClick={() => onSelectEntryType(entryType.id)}
                style={{
                  backgroundColor: entryType.color,
                  color: getColorContrast(entryType.color),
                }}
              >
                {entryType.icon && '< icon >'} {entryType.name}
              </Button>
            ))}
          </div>
        </div>
      ))}
    </Modal>
  )
}

export {SelectEntryTypeModal}